import { checkModulePermission } from "./permissionsMiddleWare";

export const authMiddleware = moduleName => {
  return (to, from, next) => {
    const isAccess = checkModulePermission(moduleName);
    if (!isAccess) {
      next();
    } else {
      next("/permission-denied");
    }
  };
};
//
